import React from "react";

class NumberInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 4,
    };
    this.increaseCount = this.increaseCount.bind(this);
    this.decreaseCount = this.decreaseCount.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  increaseCount() {
    if (this.state.count < 12) {
      this.setState({
        count: this.state.count + 1,
      });
    }
  }

  decreaseCount() {
    if (this.state.count > 1) {
      this.setState({
        count: this.state.count - 1,
      });
    }
  }

  handleChange({ target }) {
    const { value } = target;
    this.setState({
      count: parseInt(value),
    });
  }

  render() {
    return (
      <div className={`${this.props.className || ""} number-input`}>
        <input
          name={this.props.name || "number-input"}
          value={this.state.count}
          type="number"
          max={12}
          min={1}
          onChange={this.handleChange}
          readOnly={this.props.isPremiumCoach || false}
          style={{
            cursor: this.props.isPremiumCoach || false ? "not-allowed" : "auto",
          }}
        />
        <div className="navigation-arrows">
          <img
            className="navigation-icons"
            onClick={() => this.increaseCount()}
            alt="up"
            src="/img/svg/icon_arrow-up.svg"
          />
          <img
            className="navigation-icons"
            onClick={() => this.decreaseCount()}
            alt="down"
            src="/img/svg/icon_arrow-down.svg"
          />
        </div>
      </div>
    );
  }
}

export default NumberInput;
